import React, { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";

import { OBSERVATION_TYPE } from "./CONSTANTS";

import { CommmonService } from "app/_services/CommonService/CommonService";
import { getVFLByID } from "app/_services/ehs/VFLService";

import { OBSERVATION_CATEGORY } from "./component/ObservationTab";
import VFLTimeline from "./component/VFLTimeline";
import ViewComments from "../IncidentManagement/ViewComments";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { Link } from "react-router-dom";
import EvidenceDetailsInfo from "../IncidentManagement/EvidenceDetailsInfo";
import { TRAINEE_TYPE } from "../TrainingManagement/CONSTANTS";
import {
  useContractorDropdown,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { getContractor } from "app/_services/Contractor/ContractorService";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";

const ViewVFLCompletion = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [form, setForm] = useState({});

  const [, employeesOption] = useEmployeeDropdown();

  const [, contractorPersonsOption] = useContractorPersonDropdown();
  const [contractors] = useContractorDropdown();

  let capaFlag = false;
  for (const iterator of form?.vflObservations || []) {
    if (iterator.allCapa.length > 0) capaFlag = true;
  }

  /************ useEffect*********/
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    if (!id) return;

    getVFLByID(id).then((response) => {
      if (!response?.data) return;

      setForm({
        ...response.data,
      });
    });
  }, [id]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "View VFLs", path: "/health-safety-and-environment/vfl/manage" },
          { name: "View" },
        ]}
      />
      <div className="healthSafetyEnvironmentWrapper mt-3">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
              Timeline
            </a>
            <a className={`${tab === 2 ? "active" : ""}`} href onClick={() => setTab(2)}>
              Workflow Input
            </a>
            <a className={`${tab === 3 ? "active" : ""}`} href onClick={() => setTab(3)}>
              Info
            </a>
            <a className={`${tab === 4 ? "active" : ""}`} href onClick={() => setTab(4)}>
              Workmen Interaction
            </a>
            <a className={`${tab === 5 ? "active" : ""}`} href onClick={() => setTab(5)}>
              Observations
            </a>
            <a className={`${tab === 6 ? "active" : ""}`} href onClick={() => setTab(6)}>
              Evidence
            </a>
            {/* {form?.vflStatus === VFL_STATUS.executed && ( */}
            <a className={`${tab === 7 ? "active" : ""}`} href onClick={() => setTab(7)}>
              CAPA
            </a>
            {/* )} */}
          </div>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          {tab === 1 && (
            <div className="pt-3">
              <VFLTimeline form={form} />
            </div>
          )}

          {tab === 2 && (
            <div className="card p-3 pb-2 mt-4">
              <div className="simple-card-title mb-0">
                <h3 className="text-capitalize mb-0">Workflow Input</h3>
              </div>
              <div className="ehsFormWrapper mb-2">
                <Row>
                  <Col lg={8}>
                    {form.isBack === 1 && (
                      <p style={{ color: "red" }}>
                        {form?.backData?.length > 0 &&
                          form?.backData[form.backData.length - 1]?.comment}
                      </p>
                    )}
                    <ViewComments
                      hideTitle
                      comments={form?.incidentReviewsData}
                      viewOnly
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {tab === 3 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Info</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  <Row>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>VFL ID</h5>
                        <p className="rightData">{form?.vflId}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>VFL Executive</h5>
                        <p className="rightData">{`${userDropdownLabel(
                          form?.vflOfficerData
                        )}`}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>VFL Schedule Date</h5>
                        <p className="rightData">
                          {DDMMYYYYHHMMAFormat(form?.vflScheduledDateTime)}
                        </p>
                      </div>
                    </Col>
                    {form?.contractorInvolved ? (
                      <Col lg={4}>
                        <div className="form-group viewbox">
                          <h5>Contractor Involved</h5>
                          <p className="rightData">
                            {
                              contractors.find((d) => d.id === form?.contractorsId)
                                ?.contractorLegalEntity
                            }
                          </p>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Mine Name</h5>
                        <p className="rightData">{form?.siteData?.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Regional Office</h5>
                        <p className="rightData">{form?.siteData?.parentSite?.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Department</h5>
                        <p className="rightData">{form?.departmentId}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Area of Operation</h5>
                        <p className="rightData">{form?.ehs_area_of_operations?.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Sub Area of Operation</h5>
                        <p className="rightData">
                          {form?.subAreaId === 0
                            ? "Other"
                            : (
                                form?.ehs_area_of_operations?.subAreaOfOperation || []
                              ).find((d) => d.id === form?.subAreaId)?.name}
                        </p>
                      </div>
                    </Col>
                    {form?.subAreaId === 0 && (
                      <Col lg={4}>
                        <div className="form-group viewbox">
                          <h5>Other Sub Area</h5>
                          <p className="rightData">{form?.otherSubArea}</p>
                        </div>
                      </Col>
                    )}
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Activity</h5>
                        <p className="rightData">{form?.ehs_activity?.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Sub Activity</h5>
                        <p className="rightData">
                          {
                            (form?.ehs_activity?.subActivity || []).find(
                              (d) => d.id === form?.subActivityId
                            )?.name
                          }
                        </p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Location ID</h5>
                        <p className="rightData">{form?.siteData?.siteId}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>RO ID</h5>
                        <p className="rightData">{form?.siteData?.parentSite?.siteId}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>VFL System Time Stamp</h5>
                        <p className="rightData">
                          {DDMMYYYYHHMMAFormat(form?.createdAt)}
                        </p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>State</h5>
                        <p className="rightData">{form?.siteData?.state?.name}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>Country</h5>
                        <p className="rightData">
                          {form?.siteData?.state?.country_master?.name}
                        </p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group viewbox">
                        <h5>VFL Conducted On</h5>
                        <p className="rightData">
                          {DDMMYYYYHHMMAFormat(form.vflCompletionDateTime)}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          )}

          {tab === 4 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Workmen Interaction</h3>
              </div>
              <div className="w-100">
                <Row>
                  <Col lg={6}>
                    <div className="form-group viewbox">
                      <h5>Brief about on-going Operations</h5>
                      <p className="rightData">
                        {form?.workmen_interactions?.operationBrief}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group viewbox">
                      <h5>Understanding of the Workmen on Safety</h5>
                      <p className="rightData">
                        {form?.workmen_interactions?.workmenUnderstandingOnSafety}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group viewbox">
                      <h5>Safety Briefing Provided to Workmen</h5>
                      <p className="rightData">
                        {form?.workmen_interactions?.safetyProvidedToWorkmen}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group viewbox">
                      <h5>Other Remarks</h5>
                      <p className="rightData">{form?.workmen_interactions?.remark}</p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group viewbox">
                      <h5>Number of Workpersons Interacted with</h5>
                      <p className="rightData">
                        {form?.workmen_interactions?.numberOfWorkpersons}
                      </p>
                    </div>
                  </Col>
                </Row>
                <h5>Key Workmen Interacted with</h5>
                {form?.workmen_interactions?.workmenInteractedWith?.map((data, index) => {
                  const traineeOption = (() => {
                    switch (data?.type) {
                      case "employee":
                        return employeesOption;
                      case "contractorPerson":
                        return contractorPersonsOption;

                      default:
                        return [];
                    }
                  })();
                  return (
                    <div key={index} className="detailsGroup">
                      <Row>
                        <Col lg={6}>
                          <div className="form-group viewbox">
                            <h5>Type</h5>
                            <p className="rightData">{TRAINEE_TYPE[data.type]}</p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group viewbox">
                            <h5>Name</h5>
                            <p className="rightData">
                              {traineeOption?.find((d) => +d.id === +data.userId)?.label}
                            </p>
                          </div>
                        </Col>
                        {/* <li>
                            <span className="txtgrey">Brief about on-going Operations:</span>
                            <span className="rightData">{data.operationBrief}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Understanding of the Workmen on Safety:</span>
                            <span className="rightData">{data.workmenUnderstandingOnSafety}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Safety Briefing Provided to Workmen:</span>
                            <span className="rightData">{data.safetyProvidedToWorkmen}</span>
                          </li>
                          <li>
                            <span className="txtgrey">Other Remarks:</span>
                            <span className="rightData">{data.remark}</span>
                          </li> */}
                      </Row>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {tab === 5 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Observations</h3>
              </div>
              <div className="w-100">
                {!form?.vflObservations?.length ? (
                  <div className="text-danger">Not Applicable</div>
                ) : (
                  form?.vflObservations.map((data, index) => (
                    <div key={index} className="detailsGroup">
                      <Row>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Observation</h5>
                            <p className="rightData">
                              {data.observation || "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Type</h5>
                            <p className="rightData">
                              {OBSERVATION_TYPE.find((d) => d.id === data.type)?.label ||
                                "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Category</h5>
                            <p className="rightData">
                              {data?.categoryData?.name || "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Sub-Category</h5>
                            <p className="rightData">
                              {(data?.categoryData?.subCategory || []).find(
                                (d) => d.id === +data?.subCategory
                              )?.name || "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Potential</h5>
                            <p className="rightData">
                              {data.potential || "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="form-group viewbox">
                            <h5>Severity</h5>
                            <p className="rightData">
                              {data.severity || "Not Applicable"}
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {tab === 6 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Evidence</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {form?.evidences?.length ? (
                    form?.evidences.map((data) => (
                      <EvidenceDetailsInfo viewFormat key={data.id} {...data} />
                    ))
                  ) : (
                    <p class="text-danger">Not Applicable</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {tab === 7 && (
            <div className="card p-3 pb-0 mt-4">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">CAPA</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {!capaFlag ? (
                    <p class="text-danger">Not Applicable</p>
                  ) : (
                    form?.vflObservations
                      .filter((d) => !["safeCondition", "safeAct"].includes(d.type))
                      .map((observation) => {
                        return (
                          <div className="pb-4" key={observation.id}>
                            <h5 className=".font-weight-bold pb-3">
                              {
                                OBSERVATION_CATEGORY.find(
                                  (data) => data.id === observation.type
                                )?.label
                              }
                            </h5>
                            {observation?.allCapa.map((data, index) => (
                              <div key={data.id} className="detailsGroup">
                                <Row>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>CAPA Id</h5>
                                      <p className="rightData">
                                        <Link
                                          to={`/health-safety-and-environment/capa-management/manage-capa/update/${data.id}`}
                                        >
                                          {data.capaId}
                                        </Link>{" "}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>CAPA Type</h5>
                                      <p className="rightData">{data.capaType}</p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Area</h5>
                                      <p className="rightData">{data?.workArea?.name}</p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Sub Area</h5>
                                      <p className="rightData">
                                        {data?.subAreaId === 999
                                          ? "Other"
                                          : (
                                              data?.workArea?.subAreaOfOperation || []
                                            ).find((d) => d.id === data?.subAreaId)?.name}
                                      </p>
                                    </div>
                                  </Col>
                                  {data?.subAreaId === 999 && (
                                    <Col lg={3}>
                                      <div className="form-group viewbox">
                                        <h5>Other Sub Area</h5>
                                        <p className="rightData">{data.otherSubArea}</p>
                                      </div>
                                    </Col>
                                  )}
                                  <Col lg={4}>
                                    <div className="form-group viewbox">
                                      <h5>CAPA Owner</h5>
                                      <p className="rightData">
                                        {" "}
                                        {userDropdownLabel(data.owner)}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Priority</h5>
                                      <p className="rightData">{data.priority}</p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Due Date</h5>
                                      <p className="rightData">{data.dueDate}</p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Status</h5>
                                      <p className="rightData">Completed</p>
                                    </div>
                                  </Col>
                                  <Col lg={2}>
                                    <div className="form-group viewbox">
                                      <h5>Completion Date</h5>
                                      <p className="rightData">{data.completionDate}</p>
                                    </div>
                                  </Col>
                                  <Col lg={4}>
                                    <div className="form-group viewbox">
                                      <h5>CAPA Description</h5>
                                      <p className="rightData">{data.solution}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        );
                      })
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="mt-4 text-center">
            <span className="btn btn-secondary mx-2" onClick={history.goBack}>
              Go Back
            </span>
          </div>
        </Col>

        {/* <Col lg={3}>
          <div className="mt-4">
            <h5>You are editing as an VFL Officer.</h5>

            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle as={Card.Header} eventKey="10" className="rightIncidentCard p-0">
                  <div className="rightInfoTitle">
                    VFL
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <VFLDetailsInfo form={form} />
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </div>
        </Col> */}
      </Row>
    </>
  );
};

export default ViewVFLCompletion;
